<div class="dialog__wrapper">
  <form [formGroup]="formArray" (ngSubmit)="handleFormSubmit()">
    <div mat-dialog-title class="dialog__title-wrapper">
      <div class="dialog__header">
        <h4 class="dialog__title">
          Authorised OPAs for <strong>{{ data.senderId.senderIDText }}</strong>
        </h4>
        <button mat-dialog-close mat-icon-button>
          <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
        </button>
      </div>

      <div class="dialog__instruction-text">
        <p>
          ONLY select the SMS Provider(s) (OPAs) that you use or intend to use. You can update this selection later if required. DO NOT select those
          you do not use.
        </p>
        <p>
          A SenderID may be handled by multiple SMS Providers (OPAs), but normally by no more than five. In the event that more than five SMS
          Providers (OPAs) are authorised, we may request further information to ensure the selection was what was intended. Failure to provide
          further information may lead to your SenderID application being rejected or revoked.
        </p>
      </div>

      <mat-form-field subscriptSizing="dynamic" class="dialog__filter" *ngIf="!isFetching">
        <mat-label>Search...</mat-label>
        <input type="text" matInput [formControl]="filter" />
      </mat-form-field>
    </div>
    <mat-dialog-content>
      <div>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="opa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>OPA</th>
            <td mat-cell *matCellDef="let element">
              <span [siAuthorisationStatus]="element">
                {{ element.organisationName }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="radio-select__container">
                <mat-slide-toggle [formControl]="getFormArrayControl(element)" color="primary">
                  {{ getFormArrayControl(element).value ? OPAStatusDesc.Authorised : OPAStatusDesc.NotAuthorised }}
                </mat-slide-toggle>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: columns"></tr>

          <tr *matNoDataRow>
            <td colspan="3" *ngIf="!isFetching">Authorised OPAs list is empty</td>
          </tr>
        </table>
        <div class="dialog__spinner">
          <div *comSpinner="isFetching; color: 'primary'; diameter: 30"></div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-stroked-button (click)="handleClose()" type="button" class="button--secondary button--pad-right">Close</button>
      <button mat-raised-button type="submit" [disabled]="disableSaveButton">Confirm</button>
    </mat-dialog-actions>
  </form>
</div>
